import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

/**
 * Create a JIRA support ticket
 */
export const createSupportTicket = createAsyncThunk(
  "helpDesk/createSupportTicket",
  async (ticketData, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log('[Help Desk Thunk] Creating support ticket');
      
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.post(
        `${baseURL}/api/help-desk/create-ticket`,
        ticketData,
        config
      );
      
      console.log('[Help Desk Thunk] Support ticket created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('[Help Desk Thunk] Error creating support ticket:', error);
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

/**
 * Test JIRA configuration and connectivity
 */
export const testJiraConnection = createAsyncThunk(
  "helpDesk/testJiraConnection",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log('[Help Desk Thunk] Testing JIRA connection');

      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(
        `${baseURL}/api/help-desk/config`,
        config
      );

      console.log('[Help Desk Thunk] JIRA connection test completed:', response.data);
      return response.data;
    } catch (error) {
      console.error('[Help Desk Thunk] Error testing JIRA connection:', error);
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

/**
 * Fetch current user's open support tickets
 */
export const fetchUserTickets = createAsyncThunk(
  "helpDesk/fetchUserTickets",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log('[Help Desk Thunk] Fetching user tickets');

      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(
        `${baseURL}/api/help-desk/user-tickets`,
        config
      );

      console.log('[Help Desk Thunk] User tickets fetched successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('[Help Desk Thunk] Error fetching user tickets:', error);
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);